import { render, staticRenderFns } from "./AsyncFile.vue?vue&type=template&id=40c3ec4a&"
import script from "./AsyncFile.vue?vue&type=script&lang=js&"
export * from "./AsyncFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports